const rolls = [
  { race: 'Artrell', str: 10, cha: 9, con: 6, dex: 21, int: 13, wis: 13 },
  { race: 'Centaur', str: 20, cha: 10, con: 21, dex: 18, int: 11, wis: 11 },
  { race: 'Dragon', str: 22, cha: 22, con: 22, dex: 22, int: 22, wis: 22 },
  { race: 'Drow-elf', str: 13, cha: 17, con: 15, dex: 17, int: 22, wis: 22 },
  { race: 'Dwarf', str: 17, cha: 11, con: 19, dex: 18, int: 14, wis: 19 },
  { race: 'Elf', str: 15, cha: 16, con: 15, dex: 18, int: 20, wis: 22 },
  { race: 'Faerie', str: 6, cha: 20, con: 6, dex: 22, int: 22, wis: 22 },
  { race: 'Giant', str: 22, cha: 13, con: 22, dex: 9, int: 11, wis: 6 },
  { race: 'Gnoll', str: 17, cha: 16, con: 22, dex: 16, int: 15, wis: 15 },
  { race: 'Gnome', str: 14, cha: 8, con: 14, dex: 16, int: 20, wis: 20 },
  { race: 'Goblin', str: 22, cha: 6, con: 21, dex: 20, int: 14, wis: 14 },
  { race: 'Halfling', str: 13, cha: 11, con: 12, dex: 22, int: 14, wis: 15 },
  { race: 'Half-elf', str: 15, cha: 17, con: 13, dex: 19, int: 13, wis: 10 },
  { race: 'Half-ogre', str: 21, cha: 10, con: 22, dex: 18, int: 10, wis: 7 },
  { race: 'Half-orc', str: 20, cha: 9, con: 21, dex: 16, int: 14, wis: 12 },
  { race: 'Hobbit', str: 14, cha: 16, con: 12, dex: 22, int: 13, wis: 11 },
  { race: 'Human', str: 14, cha: 18, con: 14, dex: 15, int: 16, wis: 15 },
  { race: 'Imp', str: 8, cha: 15, con: 8, dex: 22, int: 22, wis: 22 },
  { race: 'Kender', str: 10, cha: 19, con: 20, dex: 22, int: 19, wis: 7 },
  { race: 'Kobold', str: 18, cha: 15, con: 18, dex: 18, int: 16, wis: 16 },
  { race: 'Lich', str: 15, cha: 6, con: 22, dex: 15, int: 22, wis: 22 },
  { race: 'Nymph', str: 11, cha: 22, con: 14, dex: 22, int: 10, wis: 6 },
  { race: 'Ogre', str: 22, cha: 6, con: 22, dex: 17, int: 9, wis: 6 },
  { race: 'Ogre-magi', str: 22, cha: 8, con: 22, dex: 17, int: 21, wis: 21 },
  { race: 'Orc', str: 22, cha: 8, con: 22, dex: 14, int: 10, wis: 6 },
  { race: 'Satyr', str: 21, cha: 7, con: 21, dex: 17, int: 8, wis: 10 },
  { race: 'Troll', str: 19, cha: 12, con: 18, dex: 15, int: 15, wis: 15 },
  { race: 'Were-wolf', str: 22, cha: 10, con: 22, dex: 22, int: 10, wis: 10 },
];

export default rolls;
